import React from "react";
import { T } from "services/lang/LanguageService";
import { useGetProductTemplateInfo } from "../../../api/api-hooks/product-templates-hooks";

interface IProductTemplateTitleProps {
  value: number | null;
}

export default function ProductTemplateTitle(props: IProductTemplateTitleProps) {
  const query = useGetProductTemplateInfo(props.value, { enabled: props.value != null });

  const loading = query.isLoading;

  const displayName = query.data?.displayName || "-";

  return (
    <>
      {props.value == null ? (
        T("message.product-template-not-selected")
      ) : (
        <>
          {loading && T("word.loading")}

          {query.isError && T("alert.error")}

          {!query.isLoading && !query.isError && displayName}
        </>
      )}
    </>
  );
}
